import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { useLang } from "../../i18n/LanguageContext";
import { Icon } from "../common";
import { CONTACT, whatsappLink } from "../../data/site";

export const FloatingActions = () => {
  const { t } = useLang();
  const nav = useNavigate();
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const Btn = ({ icon, label, onClick, href, cls, testid }) => {
    const inner = (
      <motion.span whileHover={{ scale: 1.08 }} whileTap={{ scale: 0.94 }}
        className={`group relative grid place-items-center h-12 w-12 rounded-full shadow-lg ${cls}`}>
        <Icon name={icon} size={20} />
        <span className="pointer-events-none absolute end-14 whitespace-nowrap rounded-lg bg-navy px-3 py-1.5 text-xs text-white opacity-0 group-hover:opacity-100 transition-opacity">{label}</span>
      </motion.span>
    );
    return href
      ? <a href={href} target="_blank" rel="noreferrer" aria-label={label} data-testid={testid}>{inner}</a>
      : <button onClick={onClick} aria-label={label} data-testid={testid}>{inner}</button>;
  };

  return (
    <div className="fixed bottom-5 end-5 z-40 flex flex-col items-center gap-3">
      <Btn icon="MessageCircle" label={t.cta.whatsapp} href={whatsappLink()} cls="bg-[#25D366] text-white" testid="float-whatsapp" />
      <Btn icon="Phone" label={t.cta.call} href={`tel:${CONTACT.phoneRaw}`} cls="bg-blue text-white" testid="float-call" />
      <Btn icon="FileText" label={t.cta.quote} onClick={() => nav("/quote")} cls="bg-navy text-white" testid="float-quote" />
      <AnimatePresence>
        {show && (
          <motion.div initial={{ opacity: 0, scale: 0.5 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.5 }}>
            <Btn icon="ArrowUp" label={t.cta.backTop} onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} cls="bg-white text-navy border border-black/10" testid="float-top" />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default FloatingActions;
